const SECRET_KEY = "bc397Zam6e7&^^%mfd-d0PlaPliyaf1-+9wh4defSu-9a7dr-9647sub43re706veyeb";

const getKey = async (): Promise<CryptoKey> => {
  const encoder = new TextEncoder();

  const keyMaterial = await crypto.subtle.digest("SHA-256", encoder.encode(SECRET_KEY));

  return crypto.subtle.importKey(
    "raw",
    keyMaterial,
    {
      name: "AES-GCM",
    },
    false,
    ["encrypt"]
  );
};

const uint8ToBase64 = (bytes: Uint8Array): string => {
  let binary = "";

  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });

  return btoa(binary);
};

export const encryptZS = async (data: string): Promise<string> => {
  const key = await getKey();

  // AES-GCM standard IV = 12 bytes
  const iv = crypto.getRandomValues(new Uint8Array(12));

  const encodedData = new TextEncoder().encode(String(data));

  const encrypted = await crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv,
      tagLength: 128,
    },
    key,
    encodedData
  );

  const encryptedBytes = new Uint8Array(encrypted);

  // Web Crypto output:
  // ciphertext + authTag
  //
  // Final format:
  // IV + ciphertext + authTag

  const result = new Uint8Array(iv.length + encryptedBytes.length);

  result.set(iv, 0);
  result.set(encryptedBytes, iv.length);

  return uint8ToBase64(result);
};
